module.exports = __webpack_public_path__ + "static/media/saml.494d20b7.svg";